export enum BrowserOS {
  MacOS = 'macOS',
  Windows = 'windows',
}

const getRunningBrowserOS = (): BrowserOS | undefined => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('macintosh')) {
    return BrowserOS.MacOS;
  }
  if (userAgent.includes('windows') || userAgent.includes('linux')) {
    return BrowserOS.Windows;
  }
  return undefined;
};

export default getRunningBrowserOS;
